export const gridTheme = {
  breakpoints: {
    // defaults below
    xxl: 1400,
    xl: 1200,
    lg: 992,
    md: 768,
    sm: 576,
    xs: 575,
  },
  row: {
    padding: 12,
  },
  col: {
    padding: 12,
  },
  container: {
    padding: 24,
    maxWidth: {
      xxl: 1400,
      xl: 1200,
      lg: 960,
      md: 750,
      sm: 540,
      xs: 540,
    },
  },
};
